import { Construction } from "lucide-react";

const MaintenancePage = ({ message }) => {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <Construction className="w-12 h-12 text-sage" />
        </div>
        <h1 className="font-heading font-bold text-4xl text-charcoal mb-4">
          Coming Soon
        </h1>
        <p className="text-lg text-charcoal/70 mb-8">
          {message || "We're getting things ready. Please check back soon."}
        </p>
        <div className="flex items-center justify-center gap-3">
          <div className="w-10 h-10 bg-sage/10 rounded-xl flex items-center justify-center">
            <svg viewBox="0 0 40 40" fill="none" className="w-6 h-6">
              <path d="M20 4C20 4 24 10 24 16C24 18 22 20 20 20C18 20 16 18 16 16C16 10 20 4 20 4Z" stroke="#5B7B5B" strokeWidth="1.5" fill="none"/>
              <path d="M36 20C36 20 30 24 24 24C22 24 20 22 20 20C20 18 22 16 24 16C30 16 36 20 36 20Z" stroke="#5B7B5B" strokeWidth="1.5" fill="none"/>
              <path d="M20 36C20 36 16 30 16 24C16 22 18 20 20 20C22 20 24 22 24 24C24 30 20 36 20 36Z" stroke="#5B7B5B" strokeWidth="1.5" fill="none"/>
              <path d="M4 20C4 20 10 16 16 16C18 16 20 18 20 20C20 22 18 24 16 24C10 24 4 20 4 20Z" stroke="#5B7B5B" strokeWidth="1.5" fill="none"/>
              <circle cx="20" cy="20" r="3" fill="#C41E7F"/>
            </svg>
          </div>
          <span className="font-heading font-bold text-charcoal">Magnolia Events and Rentals LLC</span>
        </div>
        <p className="text-sm text-charcoal/50 mt-8">
          For urgent inquiries, please contact us at alex@magnolia-events.com
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
